
import { State, Action } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';

const namespace: string = 'app';

@Component({
  components: {
  },
})

export default class TenantSwitcher extends Vue {
  // @Prop({ default: false })
  // public noLinkCta!: boolean;

  protected dialogVisible: boolean = false;

  public ShowPrompt(item?: any) {
    this.dialogVisible = true;
  }

  public HidePrompt() {
    this.dialogVisible = false;
  }
}
